import React from 'react';
import _ from 'lodash';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import { isPathHidden, isNavItemHidden } from 'config/helpers';
import { Button } from 'components/landing/components';
import Link from './Link';

const dumbNavigation = dumbBem('landing-nav');
const NavLink = tx([{ element: 'link' }, dumbNavigation])('div');

let nav = [
  { to: '/', name: 'Product', exact: true, group: 'default' },
  { to: '/services', name: 'Services', group: 'default' },
  { to: '/pricing', name: 'Pricing', group: 'default' },
  { to: '/careers', name: 'Careers', group: 'default' },
  { to: '/login', name: 'Login', modifier: 'login', group: 'auth' },
  { to: '/signup', name: 'SIGNUP', group: 'auth' },
];

nav = _.filter(nav, (route) => !isPathHidden(route.to));
nav = _.filter(nav, (route) => !isNavItemHidden(route.to));

export const navConfig = nav;
export const groupedNavConfig = _.groupBy(navConfig, 'group');

export const renderNavigationFromConf = (config, onClick = () => {}) => {
  if (!config) return null;
  return config.map(
    (route, id) => {
      const Element = route.name === 'SIGNUP' ? Button : NavLink;
      return (
        <Link key={id} exact={route.exact || false} to={route.to} onClick={onClick}>
          <Element modifier={route.modifier || ''}>{route.name}</Element>
        </Link>
      );
    },
  );
};



// WEBPACK FOOTER //
// ./src/components/landing/components/navigation/config.js